import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';

const BalanceText = ({ virtualAccountResource }) => {
  return (
    <Typography
      color="primary"
      variant={'h6'}
      weight={'medium'}
    >
      {virtualAccountResource.attr('balance')}
    </Typography>
  );
};

BalanceText.propTypes = {
  virtualAccountResource: PropTypes.object.isRequired,
};

export default BalanceText;
